import classNames from "classnames";
import { useEffect } from "react";
import tryLazyLoad from "@libs/utils/lazyLoad";
import type { FC, ReactNode } from "react";

type LazyBgImageProps = {
  className?: string;
  src: string;
  children?: ReactNode;
};

// SEE: https://github.com/verlok/vanilla-lazyload#usage-with-react
const LazyBgImage: FC<LazyBgImageProps> = ({
  src,
  className = "",
  children = null,
}) => {
  useEffect(() => {
    tryLazyLoad();
  });

  return (
    <div className={classNames("lazy", className)} data-bg={src}>
      {children}
    </div>
  );
};

export default LazyBgImage;
